'use strict';
module.exports = [
  '$rootScope',
  '$scope',
  '$q',
  '$state',
  '$filter',
  '$uibModal',
  'sourceService',
  'situationRecordService',
  'situationRecordClass',
  'translateFilter',
  'toastService',
  'datex2EnumsService',
  'errorHandlerService',
  'datex2EnumsTranscodeFilter',
  function (
    $rootScope,
    $scope,
    $q,
    $state,
    $filter,
    $uibModal,
    sourceService,
    situationRecordService,
    situationRecordClass,
    translateFilter,
    toastService,
    datex2EnumsService,
    errorHandlerService,
    datex2EnumsTranscodeFilter
  ) {
    //var mainConfig=$rootScope.configs.ngDroAstralSituationRecordMainConfig;
    var mainConfig = global.ngDroAstralSituationRecordMainConfig;
    /**
     * Lista fonti
     */
    $scope.sourceList = [];

    /**
     * Enumerazioni Datex2
     */
    $scope.datex2Enums = undefined;

    //*********************************************************************
    //**************************PAGINAZIONE****************************
    //*********************************************************************

    var defaultPagination = {
      page: 0,
      size: mainConfig.PageSize,
      sort: 'comment.comment.keyword,ASC',
    };

    $scope.curPaginationPage = defaultPagination.page;
    $scope.curPaginationSize = defaultPagination.size;
    $scope.curPaginationSort = defaultPagination.sort;
    $scope.curTotItems = 0;

    //*******************************************************************
    //
    //*******************************************************************
    //********************        EXPORT TO CSV               ***********
    //*******************************************************************

    $scope.csv = {
      separator: ';',
      filename: translateFilter('AstralSituationRecord.sourceList') + '.csv',
    };
    $scope.getCsvHeader = function () {
      var csvHeader = [
        translateFilter('AstralSituationRecord.type'),
        translateFilter('AstralSituationRecord.description'),
        translateFilter('AstralSituationRecord.isSystem'),
        translateFilter('AstralSituationRecord.reliable'),
      ];
      return csvHeader;
    };

    $scope.getCsvData = function () {
      var deferred = $q.defer();

      var csvData = [];

      getSources().then(
        function () {
          var searchRes = $scope.getSourcesResponse.content;
          if (searchRes) {
            angular.forEach(searchRes, function (obj) {
              if (obj) {
                var row = {
                  sourceType:
                    obj.sourceType !== undefined && obj.sourceType !== null
                      ? datex2EnumsTranscodeFilter(obj.sourceType, $scope.datex2Enums.sourceType)
                      : '',
                  description:
                    obj.comment.comment !== undefined && obj.comment.comment !== null
                      ? obj.comment.comment
                      : '',
                  isSystemSource:
                    obj.isSystemSource !== undefined && obj.isSystemSource !== null
                      ? obj.isSystemSource
                      : '',
                  reliable: obj.reliable !== undefined && obj.reliable !== null ? obj.reliable : '',
                };
                csvData.push(row);
              }
            });
          }
          deferred.resolve(csvData);
        },
        function (errors) {
          errorHandler(errors);
          deferred.reject();
        }
      );

      return deferred.promise;
    };
    //*******************************************************************

    //*******************************************************************
    //********************        ORDINAMENTO TABELLA        ************
    //*******************************************************************
    var defaultTableOrder = {
      field: 'description',
      reverseSort: false,
    };

    $scope.order = function (field) {
      if (field) {
        $scope.curTableOrder.reverseSort =
          $scope.curTableOrder.field === field ? !$scope.curTableOrder.reverseSort : false;
        $scope.curTableOrder.field = field;
      }
    };

    //*******************************************************************

    //*********************************************************************
    //**************************GESTIONE ERRORE ***************************
    //*********************************************************************
    /**
     * Array Errori di Validazione
     */
    $scope.validationErrors = [];
    /**
     * Management errori di validazione riscontrati al salvataggio
     * @return {undefined}
     */
    function errorHandler(error, successMessage, errorMessage) {
      $scope.validationErrors = [];
      errorHandlerService
        .handle(error, successMessage, errorMessage)
        .then(function (validationErrors) {
          $scope.validationErrors = validationErrors;
        });
      if (error && error.status && error.status === errorHandlerService.status500) {
        doCloseSource();
      }
    }
    //                function getValidationErrorFieldName(listName, index, propertyName) {
    //                    var fieldName = listName;
    //                    if (index !== undefined)
    //                        fieldName = fieldName + index;
    //                    if (propertyName)
    //                        fieldName = fieldName + "_" + propertyName;
    //
    //                    return fieldName;
    //                }
    //                ;

    $scope.getValidationErrorPopoverIsOpen = function (listName, index, propertyName) {
      var fieldName = errorHandlerService.getValidationErrorFieldName(
        listName,
        index,
        propertyName
      );
      return $scope.validationErrors.hasOwnProperty(fieldName);
    };

    /**
     * Parsa i valori in $scope.validationErrors per i campi di tipo lista
     * @param {type} listName
     * @param {type} index
     * @param {type} property
     * @return {undefined}P
     */
    $scope.getValidationErrorPopoverMessage = function (listName, index, propertyName) {
      var fieldName = errorHandlerService.getValidationErrorFieldName(
        listName,
        index,
        propertyName
      );

      return $scope.validationErrors[fieldName];
    };

    //*********************************************************************

    //*********************************************************************
    //**************************RICERCA FONTI  ****************************
    //*********************************************************************

    /**
     * Caricamento Situation Record Source
     * @return {deferred.promise}
     */
    /**
     * Ricerca eventi
     * @param {type} filter
     * @param {type} page
     * @param {type} size
     * @param {type} sort
     * @return {.$q@call;defer.promise}
     */
    function getSources(page, size, sort) {
      var deferred = $q.defer();
      $scope.getSourcesResponse = undefined;
      //verifica dei filtri impostati

      var params = {};
      if (page !== undefined && page) params.page = page - 1;
      if (size) params.size = size;
      if (sort) params.sort = sort;

      sourceService.getAll(
        params,
        function (res) {
          $scope.getSourcesResponse = res;

          deferred.resolve();
        },
        function (errors) {
          errorHandler(errors);

          deferred.reject();
        }
      );
      return deferred.promise;
    }
    $scope.search = function () {
      $scope.curTableOrder = defaultTableOrder;

      $scope.sourceList = [];
      getSources($scope.curPaginationPage, $scope.curPaginationSize, $scope.curPaginationSort).then(
        function () {
          $scope.sourceList = $scope.getSourcesResponse.content;
          $scope.curTotItems = $scope.getSourcesResponse.totalElements;
          if (!$scope.sourceList || $scope.sourceList.length === 0) {
            var msg = translateFilter('AstralSituationRecord.noResultFound');
            $scope.curTotItems = 0;
            toastService.createWarningToast(msg);
          }
        },
        function (errors) {
          errorHandler(errors);
        }
      );
    };

    //*******************************************************************

    //*********************************************************************
    //**************************FONTI - CURL OPERATIONS  ******************
    //*********************************************************************
    function createSource() {
      sourceService.create(
        $scope.curSource,
        function () {
          var msg = translateFilter('AstralSituationRecord.saveSuccess');
          toastService.createSuccessToast(msg);
          $scope.search();
          doCloseSource();
        },
        function (errors) {
          errorHandler(errors);
        }
      );
    }
    function updateSource() {
      sourceService.update(
        $scope.curSource,
        function () {
          var msg = translateFilter('AstralSituationRecord.saveSuccess');
          toastService.createSuccessToast(msg);
          $scope.search();
          doCloseSource();
        },
        function (errors) {
          errorHandler(errors);
        }
      );
    }
    $scope.saveSource = function () {
      if (!$scope.curSource) {
        errorHandler(
          undefined,
          undefined,
          translateFilter('AstralSituationRecord.notValidParameter')
        );
      } else {
        if ($scope.curSource.id === undefined) {
          createSource();
        } else {
          updateSource();
        }
      }
    };

    $scope.deleteSource = function (source) {
      var dialogInst = $uibModal.open({
        template: require('../modal/modalQuest.html'),
        controller: 'modalQuestCtrl',
        size: 'sm',
        resolve: {
          params: function () {
            return {
              headerMessage: translateFilter('AstralSituationRecord.attention'),
              bodyMessage:
                translateFilter('AstralSituationRecord.deleteItemQuest') + ' Id:' + source.id,
              showCancelButton: true,
              showNoButton: false,
              showYesButton: true,
              cancelButtonText: translateFilter('AstralSituationRecord.cancel'),
              yesButtonText: translateFilter('AstralSituationRecord.ok'),
            };
          },
        },
      });
      dialogInst.result.then(
        function () {
          delSource(source.id).then(function () {
            //refresh della pagina
            $scope.search();
          });
        },
        function () {}
      );
    };

    function delSource(id) {
      var deferred = $q.defer();
      if (id) {
        //verifico se ci sono situation records legati a questo source
        var params = {
          page: 0,
          size: 1,
          sort: undefined,
        };

        var d1 = new Date();
        var filter = {
          //source: id,
          sourceList: [id],
          clazz: situationRecordClass.getSituationRecordTypes().situationRecordFilter,
          validityPeriodsDateStart: new Date(1900, 1, 1, 0, 0, 0),
          validityPeriodsDateEnd: new Date(
            d1.getFullYear() + 10,
            d1.getMonth(),
            d1.getDate(),
            0,
            0,
            0
          ),
          topLeft: {
            x: -180,
            y: 90,
            z: null,
          },
          bottomRight: {
            x: 180,
            y: -90,
            z: null,
          },
        };
        situationRecordService.search(
          params,
          filter,
          function (res) {
            if (res.totalElements) {
              //ci sono dei situation record legati al source che si cerca di cancellare --> ERRORE
              var error = {
                data: {
                  description: translateFilter(
                    'AstralSituationRecord.Error.sourceDelExistingSituationRecord'
                  ),
                },
              };

              errorHandler(error, undefined, error.data.description);

              deferred.reject(error);
            } else {
              //non ci sono dei situation record legati al source che si cerca di cancellare --> ESEGUO CANCELLAZIONE
              sourceService.delete(
                { id: id },
                function (res) {
                  //console.log('ngdro situationRecordSearchCtrl.delSituationRecord SUCCESS', res);
                  var msg = translateFilter('AstralSituationRecord.deleteSuccess');
                  toastService.createSuccessToast(msg);

                  deferred.resolve();
                },
                function (errors) {
                  errorHandler(errors);
                  //console.log('ngdro situationRecordMgmtCtrl.getSituationRecord ERROR', errors);
                  deferred.reject(errors);
                }
              );
            }
          },
          function (errors) {
            errorHandler(errors);

            deferred.reject();
          }
        );
      } else {
        toastService.createErrorToast(
          translateFilter('AstralSituationRecord.notValidParameter') + ': id'
        );
        //console.log('ngdro situationRecordMgmtCtrl.getSituationRecord ERROR', translateFilter("AstralSituationRecord.notValidParameter") + ": id " + id);

        deferred.reject();
      }

      return deferred.promise;
    }
    //*******************************************************************

    //*******************************************************************
    //*************        SIDE PANEL (SOURCE MANAGEMENT)     ***********
    //*******************************************************************

    $scope.isMgmtPanelCollapsed = true;
    $scope.curSource = undefined;
    var clazz = 'com.dromedian.jdro.datex2.domain.SourceEntity';

    function resetSource() {
      var defaultSourceCountry = 'IT';
      var defaultLocale = 'it';
      var ret = {
        clazz: clazz,
        id: undefined,
        sourceCountry: defaultSourceCountry,
        sourceType: undefined,
        comment: {
          locale: defaultLocale,
          comment: undefined,
        },
        isSystemSource: false,
        reliable: true,
      };
      return ret;
    }

    /**
     * Mostra pannello SOURCE MGMT
     * @return {undefined}
     */
    function showMgmtPanel() {
      var searchPanel = $('#searchPanel');
      var mgmtPanel = $('#mgmtPanel');

      //MOSTRA PANNELLO
      if (searchPanel.hasClass('col-xs-12')) {
        //espandi pannello laterale
        searchPanel.removeClass('col-xs-12');
        searchPanel.addClass('col-xs-8');
        mgmtPanel.addClass('col-xs-4');
      }

      $scope.isMgmtPanelCollapsed = false;
    }
    /**
     * Nascondi pannello SOURCE MGMT
     * @return {undefined}
     */
    function hideMgmtPanel() {
      var searchPanel = $('#searchPanel');
      var mgmtPanel = $('#mgmtPanel');

      if (mgmtPanel.hasClass('col-xs-4')) {
        //nascondi pannello laterale
        mgmtPanel.removeClass('col-xs-4');
        if (searchPanel.hasClass('col-xs-8')) {
          searchPanel.removeClass('col-xs-8');
          searchPanel.addClass('col-xs-12');
        }
      }
      $scope.isMgmtPanelCollapsed = true;
    }

    $scope.addSource = function () {
      if ($scope.curSource === undefined) {
        $scope.curSource = resetSource();
        showMgmtPanel();
      }
    };

    $scope.openSource = function (item) {
      if ($scope.curSource === undefined) {
        $scope.curSource = resetSource();
        $scope.curSource.id = item.id;
        $scope.curSource.sourceType = item.sourceType;
        $scope.curSource.comment.comment = item.comment.comment;
        $scope.curSource.isSystemSource = item.isSystemSource;
        $scope.curSource.reliable = item.reliable;

        showMgmtPanel();
      }
    };

    function doCloseSource() {
      $scope.curSource = undefined;
      hideMgmtPanel();
      $scope.validationErrors = [];
    }
    $scope.closeSource = function () {
      //verifico se l'utente ha apportato modifiche
      if ($scope.sourceMgmtForm.$dirty) {
        var dialogInst = $uibModal.open({
          template: require('../modal/modalQuest.html'),
          controller: 'modalQuestCtrl',
          size: 'md',
          resolve: {
            params: function () {
              return {
                headerMessage: translateFilter('AstralSituationRecord.attention'),
                bodyMessage: translateFilter('AstralSituationRecord.notSavedChanges'),
                showCancelButton: true,
                showNoButton: true,
                showYesButton: true,
                cancelButtonText: translateFilter('AstralSituationRecord.cancel'),
                noButtonText: translateFilter('AstralSituationRecord.no'),
                yesButtonText: translateFilter('AstralSituationRecord.yes'),
              };
            },
          },
        });
        dialogInst.result.then(
          function () {
            $scope.saveSource();
          },
          function (dismissValue) {
            if (dismissValue === 'cancel') {
            }
            if (dismissValue === 'no') {
              doCloseSource();
            }
          }
        );
      } else {
        doCloseSource();
      }
    };

    //*******************************************************************

    /**
     * Caricamento Enumerazioni Datex2
     * @return {deferred.promise}
     */
    function getDatex2Enums() {
      var deferred = $q.defer();
      datex2EnumsService.getDatex2Enums(
        function (res) {
          if (res) {
            $scope.datex2Enums = angular.fromJson(res);
          }
          $scope.severityList = [];

          //console.log('ngdro situationRecordSearchCtrl.getDatex2Enums SUCCESS', $scope.datex2Enums);
          deferred.resolve();
        },
        function (errors) {
          errorHandler(errors);

          deferred.reject();
        }
      );
      return deferred.promise;
    }
    (function init() {
      getDatex2Enums().then(function () {
        $scope.search();
      });
    })();
  },
];



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-AstralSituationRecord/components/source/sourceListCtrl.js
// module id = 241
// module chunks = 0